import { useSyncExternalStore } from 'react';

/** Rupture bureau / mobile de la coque : `--bp-lg` du design system (1024 px). */
export const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * Suit une media query. Sans `matchMedia` (jsdom, rendu serveur), `fallback` s'applique : le bureau par défaut,
 * pour que les tests voient la sidebar sans avoir à simuler un écran.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  return useSyncExternalStore(
    (listener) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
      const mql = window.matchMedia(query);
      mql.addEventListener('change', listener);
      return () => mql.removeEventListener('change', listener);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : fallback),
    () => fallback,
  );
}

export const useIsDesktop = (): boolean => useMediaQuery(DESKTOP_QUERY);
